import { Component, computed, OnInit, Signal } from '@angular/core'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { NaturalStoneService } from '../../../services/natural-stone.service'
import { NaturalStoneLotCardComponent } from '../natural-stone-lot-card/natural-stone-lot-card.component'
import { ActivatedRoute, Router } from '@angular/router'
import { NgForOf, NgIf } from '@angular/common'
import { NaturalStoneLot, NaturalStoneLots } from '../../../interfaces/natural-stone/natural-stone-lots'
import { SelectValue } from '../../../interfaces/select-value.interface'
import { SelectComponent } from '@components/select/select.component'
import { NaturalStoneMiniCartComponent } from '../natural-stone-mini-cart/natural-stone-mini-cart.component'

@Component({
  selector: 'app-natural-stone-lot-list',
  standalone: true,
    imports: [
        TranslateModule,
        NaturalStoneLotCardComponent,
        NgForOf,
        NgIf,
        SelectComponent,
        NaturalStoneMiniCartComponent
    ],
  templateUrl: './natural-stone-lot-list.component.html',
  styleUrl: './natural-stone-lot-list.component.scss'
})
export class NaturalStoneLotListComponent implements OnInit{

    color!: Signal<NaturalStoneLots>;

    groupedLots: Signal<NaturalStoneLot[]>

    thicknessOptions: SelectValue[] = []
    selectedThicknessValue: SelectValue | null = null
    finishOptions: SelectValue[] = []
    selectedFinishValue: SelectValue | null = null

    areFiltersSelectable: boolean = true

    filtersLoaded = false;

    constructor(
        private route: ActivatedRoute,
        private naturalStoneService: NaturalStoneService,
        private router: Router,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        this.color = computed(() => {
            const color = this.naturalStoneService.selectedColor()
            this.areFiltersSelectable = !!color.completeData
            this.setupFilters(color)
            return color
        })
        this.groupedLots = computed(() => {
            const color = this.naturalStoneService.selectedColor()
            return this.setupLots(color)
        })

        this.route.params.subscribe(params => {
            const centerId = params['centerId']
            const sku = params['sku']

            this.naturalStoneService.loadColor(centerId, sku)
        })
    }

    private setupFilters(color: NaturalStoneLots){
        if(!color.skus || this.filtersLoaded){
            return
        }

        const availableThicknesses: Set<string> = new Set<string>()
        const availableFinishes: Set<string> = new Set<string>()

        const keys = Object.keys(color.skus)
        keys.forEach(key => {
            const splitFinishThickness = key.split('-')
            availableFinishes.add(splitFinishThickness[0])
            availableThicknesses.add(splitFinishThickness[1])
        })

        this.finishOptions = [...availableFinishes].map(finish => {
            return {
                id: finish,
                value: finish,
                label: !this.translate.instant('finishes.' + finish).includes('finishes.') ?
                    this.translate.instant('finishes.' + finish) :
                    finish
            }
        })
        this.selectedFinishValue = this.finishOptions.find(
            option => option.value === color.finish
        ) || null

        this.thicknessOptions = [...availableThicknesses].map(thickness => {
           return {
               id: thickness,
               value: thickness,
               label: thickness + ' cm'
           }
        })
        this.selectedThicknessValue = this.thicknessOptions.find(
            option => option.value === color.thickness
        ) || null

        this.filtersLoaded = true
    }

    getColorText(){
        return this.naturalStoneService.getColorText()
    }

    getBrandText(){
        return this.naturalStoneService.getBrandText()
    }

    goBack() {
        this.router.navigate(['natural-stone'])
    }

    setupLots(color: NaturalStoneLots){
        console.log('setupLots', color)
        if(color.lots){
            const groupedLots: {[key: string]: NaturalStoneLot} = {}
            for(let lot of color.lots){
                if(lot.bundleId){
                    groupedLots[lot.bundleId] = lot
                } else {
                    groupedLots[lot.lotId!] = lot
                }
            }
            return Object.values(groupedLots)
        }

        return []
    }

    changeFinish(newFinish: SelectValue | null) {
        if(!newFinish || newFinish.value === this.naturalStoneService.selectedColor().finish) return
        this.naturalStoneService.changeLotFinish(newFinish.value)
    }

    changeThickness(newThickness: SelectValue | null) {
        if(!newThickness || newThickness.value === this.naturalStoneService.selectedColor().thickness) return
        this.naturalStoneService.changeLotThickness(newThickness.value)
    }
}
